import Head from 'next/head';
import Link from 'next/link';

import { GLFHPaymentsRelatedHelpSEO } from '@/utils/constants/MetaData';

const GLFHPaymentsRelated = () => {
  return (
    <>
      <Head>
        <title>{GLFHPaymentsRelatedHelpSEO.metaTitle}</title>
        <meta
          name="description"
          content={GLFHPaymentsRelatedHelpSEO.metaDescription}
        />
        <meta
          property="og:description"
          content={GLFHPaymentsRelatedHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/help/gold-loans/glfh-payments-related/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Gold Loan Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Gold Loan from Home Payments Related
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              Gold Loan from Home Payments Related
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  What is the minimum amount I need to pay?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    During the tenure of your Gold Loan, you need to pay the
                    minimum amount due to avoid any penalty, which is the sum of
                    accrued interest to date and any other charges.
                    <br />
                    Upon the tenure completion of the Gold Loan, the total
                    amount due is the sum of the principal amount, the accrued
                    interest to date, and any other charges. You can view the
                    total amount due to date on the app that you need to pay to
                    close your Gold Loan.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  Can I foreclose my Gold Loan account?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, you can foreclose your Gold Loan account. However, if
                    you foreclose the Gold Loan account within the first 7 days
                    from the start date of your Gold Loan, you will have to pay
                    the minimum amount due which is accrued interest over 7 days
                    on your Gold Loan amount.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  Are foreclosure charges applicable?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    No, there are no foreclosure charges on our Gold Loans.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  What happens if I don’t pay my interest on time?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    If you fail to pay the accrued interest amount on time, the
                    company reserves the right to increase the Interest rate to
                    the next slab, according to the terms of the loan scheme. To
                    know more about this, please refer to the scheme terms and
                    conditions <a href="/terms-conditions">here</a>.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  What are the different modes of repayment?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can repay your Gold Loan using Net Banking, Debit Card,
                    or UPI payment method through the app. Alternatively, you
                    can repay the Gold Loan in cash at any of our Muthoot
                    FinCorp branches up to the approved cash limit.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  How much do I need to repay to close Gold Loan from Home?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can pay off your Gold Loan through monthly loan
                    repayments that include the interest levied on this loan
                    amount during the tenure that depends on the Gold Loan
                    scheme applicable.
                    <br />
                    You must repay the principal amount with the accumulated
                    interest during the loan tenure and any other charges to
                    close the Gold Loan.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <p className="text--black text--semi title">
                  Can I make part payments for Gold Loan from Home?
                </p>
              </div>
              <div
                id="collapseSeven"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, can make part payment on your Gold Loan from Home. So,
                    any repayment made above the accrued interest and other
                    charges will get adjusted against the outstanding principal
                    amount.
                    <br />
                    You can make part payments by logging into the app and
                    repaying a custom amount against your Gold Loan.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingEight"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
              >
                <p className="text--black text--semi title">
                  Are there any additional charges applicable for getting a Gold
                  Loan from Home?
                </p>
              </div>
              <div
                id="collapseEight"
                className="collapse"
                aria-labelledby="headingEight"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    No, there are no extra charges or hidden fees associated
                    with a Gold Loan from Home. The only charge applicable is
                    interest accumulated on your Gold Loan amount.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default GLFHPaymentsRelated;
